export default __webpack_public_path__ + "813557df4c7a90b1a4741a14c414bafa.otf";